/**
 * @hidden
 */
export function templateRendering(template, listeners) {
    if (!template) {
        return null;
    }
    // @ts-ignore
    var scopedSlot = this.$scopedSlots[template] || (template.toLowerCase ? this.$scopedSlots[template.toLowerCase()]
        : null);
    // @ts-ignore
    if (typeof template === 'string' && scopedSlot) {
        // @ts-ignore
        return { type: 'slot', render: scopedSlot, listeners: listeners };
    }
    if (typeof template === 'string' || typeof template === 'object' ||
        (typeof template === 'function' && template.component)) {
        return { type: 'component', render: template, listeners: listeners };
    }
    return { type: 'renderFunction', render: template, listeners: listeners };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-vue-common/dist/es/templateRendering.js
// module id = null
// module chunks = 